<template>
<div class="formGroup" :data-layout="layout">
  <div class="formGroup__body">
    <formLabel :label="label" :validation="validation"></formLabel>

    <div class="checkboxGroup">
      <label
        class="custom-control custom-checkbox"
        v-for="option in options"
        v-validate="validation"
        :key="option.value"
        :class="{'error': errors.has(name)}"
      >
        <input
          :name="name"
          type="checkbox"
          class="custom-control-input"
          :value="option.value"
          :checked="checked(option.value)"
          @change="update($event)"
        >
        <span aria-hidden="true" class="custom-control-indicator"></span>
        <span class="custom-control-description"><span>{{ option.text }}</span></span>
      </label>
    </div>
  </div>
  <div class="formGroup__footer">
    <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
    <slot></slot>
  </div>
</div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-radio',
  mixins: [mixin],
  data() {
    return {
      generatedValue: []
    }
  },
  props: {
    options: { type: Array, required: true },
    design: { type: String, default: 'checkbox' } // 'checkbox' or 'button'
  },
  computed: {},
  mounted() {
  },
  methods: {
    checked(value) {
      return this.generatedValue.indexOf(value) !== -1
    },
    update($event) {
      let value = $event.target.value
      if (this.checked(value)) {
        this.generatedValue.splice(this.generatedValue.indexOf(value), 1)
      } else {
        this.generatedValue.push(value)
      }
      this.$emit('input', this.generatedValue.join(','))
      this.$emit('change', this.generatedValue.join(','))
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormCheckbox.vue